import { Injectable, Injector, NgZone } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, Event, NavigationError, NavigationEnd } from "@angular/router";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import { AppInsightService } from "app/core/logging/services/appinsights.service";

@Injectable()
export class ErrorsService {
  private previousUrl: string | undefined;
  private currentUrl: string;

  constructor(
    private injector: Injector,
    private router: Router,
    private _zone: NgZone
  ) {
    this.currentUrl = this.router.url;

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationError) {
        this.log(event.error).subscribe((errorWithContext) => {
          this.showError(errorWithContext);
        });
      }

      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  log(error: any) {
    const appInsightService = this.injector.get(AppInsightService);
    appInsightService.logException(error);
    console.error(error);
    return Observable.of(this.addContextInfo(error));
  }

  addContextInfo(error: any) {
    const name = error.name || null;
    const time = new Date().getTime();
    const url = this.currentUrl;
    const status = error.status || null;
    const message = error.message || error.toString();

    const errorWithContext = {
      name,
      time,
      url,
      status,
      message
    };
    return errorWithContext;
  }

  showError(error: any) {
    this._zone.run(() => {
      this.router.navigate([`error`], { queryParams: error });
    });
  }
}
